import { action, observable } from 'mobx';
import MobxState from './abstract/MobxState';

const TIMEOUT_REGULAR = 1000 * 5;
const TIMEOUT_BLURED = TIMEOUT_REGULAR * 5;

class DateState extends MobxState {
  value = new Date();

  init() {
    super.init();

    this.start();
  }

  start() {
    if (window.document.hasFocus()) {
      this.focus();
    }

    window.onfocus = () => this.focus();
    window.onblur = () => this.blur();
  }

  focus() {
    this.timeout_ = TIMEOUT_REGULAR;
    this.restartLoop_();
  }

  blur() {
    this.timeout_ = TIMEOUT_BLURED;
    this.restartLoop_();
  }

  restartLoop_() {
    this.loopStop_();
    this.loopStart_();
  }

  loopStart_() {
    this.update();
    this.timer_ = setTimeout(() => this.loopStart_(), this.timeout_);
  }

  loopStop_() {
    clearTimeout(this.timer_);
  }

  update() {
    this.value = new Date();
  }
}

DateState.annotations = {
  ...MobxState.annotations,
  value: observable.ref,
  update: action,
};

export default DateState;
